'use strict'

import { Link } from 'react-router-dom'
import { formatMinutes } from './mapUtils'

/**
 * Desert Flora styled route stops itinerary.
 * Sequence badge (22px circle) + stop name + Est/Act/distance + address.
 */
export default function RouteStopsList ({ focusedRoute, mapRef, setSelectedPropertyId }) {
  if (!focusedRoute?.stops?.length) return null

  return (
    <div style={{ marginTop: 8 }}>
      <div
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          marginBottom: 4, padding: '4px 0'
        }}
      >
        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--df-ink, #1c2419)' }}>
          Route Stops ({focusedRoute.stops.length})
          {focusedRoute.meta?.missingCoordinates > 0 && (
            <span style={{ fontSize: 10.5, color: '#a9341d', fontWeight: 600, marginLeft: 4 }}>
              ({focusedRoute.meta.missingCoordinates} missing coords)
            </span>
          )}
        </span>
      </div>
      <div style={{ maxHeight: 'min(35vh, 280px)', overflowY: 'auto', overflowX: 'hidden' }}>
          {focusedRoute.stops.map((stop) => {
            const hasCoords = Number.isFinite(stop.latitude) && Number.isFinite(stop.longitude) &&
              stop.latitude !== 0 && stop.longitude !== 0
            const svcMin = stop.serviceMinutes || 0
            const medianMin = stop.medianServiceMinutes
            return (
              <div
                key={stop.aspirePropertyId}
                className="route-stop-item"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  if (hasCoords && mapRef) {
                    mapRef.panTo({ lat: stop.latitude, lng: stop.longitude })
                    mapRef.setZoom(15)
                  }
                  setSelectedPropertyId(stop.aspirePropertyId)
                }}
              >
                <div className="route-stop-seq">{stop.order}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--df-primary, #1f5e3a)', textDecoration: 'underline', cursor: 'pointer', lineHeight: 1.3 }}>
                    <Link
                      style={{ color: 'inherit', textDecoration: 'inherit' }}
                      target="_blank"
                      to={{ pathname: `https://cloud.youraspire.com/app/properties/overview/${stop.aspirePropertyId}` }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {stop.propertyName || `Aspire #${stop.aspirePropertyId}`}
                    </Link>
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--df-ink-3, #6f7a6b)', marginTop: 2 }}>
                    Est {formatMinutes(svcMin)}
                    {medianMin != null && (
                      <span>
                        {' '}&middot;{' '}
                        <span style={{ color: '#a4502f', fontWeight: 600 }}>Act {formatMinutes(medianMin)}</span>
                      </span>
                    )}
                    {stop.driveMiles != null && ` · ${stop.driveMiles} mi`}
                  </div>
                  {stop.address && (
                    <div style={{ fontSize: 11, color: 'var(--df-ink-4, #97a094)', marginTop: 1 }}>{stop.address}</div>
                  )}
                  {!hasCoords && (
                    <div style={{ fontSize: 10.5, color: '#a9341d', fontWeight: 600 }}>No coordinates</div>
                  )}
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}
